module.exports = __webpack_public_path__ + "account/img/236.3631bff8.png";